import { isH5 } from '@liepin/js-core-h5/src/env';
import { get as _get, post as _post, settingStatusHandler } from '@liepin/js-core-h5/src/request';
import { mRoot, passportRoot, wwwRoot, mAccountRoot, accountRoot } from './domain';

const UNLOGIN_CODE = 5002;
const UNLOGIN_CODE_WANGGUAN = -1401;
const INVALID_MOBILE = 103160001;
// const Status_400 = -1400; // 400 & 401 异常
// const Status_403 = -1403; // 403异常
// const Status_404 = -1404; // 404异常
// const Status_500 = -1500; // 服务端 500 异常
// const Status_701 = -1701; // 多端登录被踢掉线
// const Status_unknown = -1; // 无法处理的，未知原因导致的错误
// const Status_normal = -1000; // 无特殊说明的常规性错误，常用于通用业务异常

function unloginFilter(data) {
  if (window.unloginHandler) {
    window.unloginHandler(data);
  } else if (isH5) {
    const currentUrl = encodeURIComponent(window.location.href);
    const rdurl = encodeURIComponent(`${mRoot}/register?return_url=${currentUrl}`);
    window.location.href = `${passportRoot}/v1/logout?backurl=${rdurl}`;
  } else {
    window.location.href = wwwRoot;
  }
}

// 处理函数不要用Promise.reject拦截器中已经处理了
settingStatusHandler({
  [UNLOGIN_CODE_WANGGUAN]: unloginFilter,
  [UNLOGIN_CODE]: unloginFilter,
  [INVALID_MOBILE]: (data) => {
    if (window.invalidMobileHandle) {
      return window.invalidMobileHandle(data);
    }
    if (isH5) {
      window.location.href = `${mAccountRoot}/account/edittel/`;
    } else {
      window.location.href = `${accountRoot}/profile/getsecret`;
    }
    // } else if (isH5) {
    //   window.location.href = `${passportRoot}/secret/m/v1/checkupdatetel`;
    // } else {
    //   window.location.href = `${passportRoot}/secret/v1/index/`;
    // }
  },
});

const get = (url, sendData, options) => _get(url, {
  params: sendData,
  ...options,
}).then(({ data }) => data);

const post = (...params) => _post(...params).then(({ data }) => data);

const ajax = ({ url, data, method = 'get', ...opts }) => ((/^post$/i.test(method) ? post : get)(url, data, opts));
ajax.get = get;
ajax.post = post;

export default ajax;
